import { formatNumber } from '@/utils/formatNumber';

const filters = {
  formatNumberFilter(number) {
    return formatNumber(number);
  },
};

export default filters;
